import { Link } from 'react-router-dom';

export default function CTABanner() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20">
      <div className="relative rounded-lg overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Cinematic%20warm%20dramatic%20atmosphere%20with%20film%20projector%20beam%20of%20light%20in%20a%20dark%20theater%2C%20gold%20and%20crimson%20tones%2C%20elegant%20movie%20theater%20interior%2C%20professional%20cinematic%20photography%2C%20atmospheric%20lighting%2C%20luxurious%20aesthetic&width=1440&height=500&seq=cta-bg-01&orientation=landscape"
          alt="加入91制片厂会员"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background-50/95 via-background-50/70 to-background-50/40"></div>
        <div className="relative z-10 py-16 md:py-20 px-6 md:px-12 text-center md:text-left">
          <div className="max-w-2xl mx-auto md:mx-0">
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-50 mb-4">
              准备好开启你的<span className="text-accent-400">观影之旅</span>了吗？
            </h2>
            <p className="text-foreground-300 text-sm md:text-base mb-8 leading-relaxed">
              加入91制片厂会员，畅享2000+原创影视作品、4K超清画质、无广告纯净体验。
              新会员首月仅需9.9元，随时可取消。
            </p>
            <div className="flex flex-col sm:flex-row items-center gap-4 justify-center md:justify-start">
              <Link
                to="/about"
                className="px-8 py-3 bg-accent-500 hover:bg-accent-600 text-background-950 font-semibold text-sm rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-vip-crown-line mr-2"></i>
                立即加入会员
              </Link>
              <Link
                to="/category/juqing"
                className="px-8 py-3 bg-background-50/10 border border-foreground-50/20 text-foreground-50 font-semibold text-sm rounded-full hover:bg-background-50/20 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-eye-line mr-2"></i>
                浏览全部内容
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}